import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { useGetCoursePaymentsQuery } from "../../../hooks/useGetCoursePaymentsQuery";
import { updateCoursePayment } from "../../../services/finance/coursePayments";
import { Key_coursePayments } from "../../../utils/constants";
import { CoursePaymentType } from "../../../types/Finance";
import { useAppDispatch } from "../../../hooks/hooks";
import { routes } from "../../../routes";
import { setCoursePaymentData } from "../../../redux/slices/finance/coursePayment";
import { Lists } from "../../../components/common/Lists";
import TableComponent from "../../../components/common/Tables";
import { ConfirmAlertDialog } from "../../../components/common/ConfirmAlertDialog";

const columnNamesMap: { [key: string]: string } = {
    description: 'Nome',
};

export const CoursePayments = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [deleteItem, setDeleteItem] = useState<CoursePaymentType | null>(null);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetCoursePaymentsQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdate = useMutation(updateCoursePayment, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_coursePayments);
            toast.success('Apagado');
        },
        onError: () => {
            toast.error("Erro ao apagar.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    
    const handleClickCreate = () => {
        navigate(routes.createCoursePayment);
    };
    
    const handleEdit = (p: CoursePaymentType) => {
        dispatch(setCoursePaymentData(p));
        navigate(routes.updateCoursePayment);
    };
    
    const handleDelete = async (p: CoursePaymentType) => {
       p.status = false;
        await mutationUpdate.mutateAsync(p);
    };
    
    const confirmDelete = async () => {
        if (deleteItem) {
            await handleDelete(deleteItem);
        }
    };
    
    const openDeleteDialog = (c: CoursePaymentType) => {
        setDeleteItem(c);
    };

    const options = data?.items.map((p: CoursePaymentType) => [
        {
            label: 'Editar',
            onClick: () => handleEdit(p),
            icon: <Pencil1Icon />
        },
        {
            label: 'Excluir',
            onClick: () => openDeleteDialog(p),
            icon: <TrashIcon />
        },
    ]) || [];

    return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                }
                handleClickCreate={handleClickCreate}
            />
            <ConfirmAlertDialog
                open={!!deleteItem}
                onOpenChange={(open) => !open && setDeleteItem(null)}
                title="Esta operação é irreversível"
                item={deleteItem}
                onConfirm={confirmDelete}
                onCancel={() => setDeleteItem(null)}
            />
        </>
    );
}
